// extracted by mini-css-extract-plugin
module.exports = {"main":"ShopDetail_main__1-Mlz","left":"ShopDetail_left__2nIhl","right":"ShopDetail_right__qPUwD"};